import Icon from '../../atoms/icon';
import { faEdit, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { Col, Row } from '../../../grid';
import { GetCurrentTZ } from '../../../libs/time';
import Button from '../../molecules/button';
import { CardBlock } from '../../organisms/card';
import moment from 'moment-timezone';
import React from 'react';
import { ITalk } from './types';

interface IPatientTrackedTimeItem {
  talk: ITalk;
  editTalk: any;
  deleteTalk: any;
  setTalkForEditing: any;
}

const durationToString = (time: number, unit: string) => {
  if (time) {
    return `${time}${unit}`;
  } else {
    return '';
  }
};

const getDuration = (talk: ITalk) => {
  if (!['completed', 'manual'].includes(talk.status)) {
    return '-';
  }
  const minutes = Math.floor(talk.duration / 60);
  const seconds = talk.duration % 60;
  const duration = `${durationToString(minutes, 'm')} ${durationToString(
    seconds,
    's'
  )}`;

  return duration;
};

const PatientTrackedTimeItem = ({
  talk,
  editTalk,
  deleteTalk,
  setTalkForEditing
}: IPatientTrackedTimeItem): JSX.Element => {
  const createdAt = moment
    .tz(talk.createdAt, GetCurrentTZ())
    .format('MM/DD/YYYY, h:mma zz');
  const handleEdit = () => {
    setTalkForEditing(talk);
    editTalk(talk.id);
  };
  return (
    <CardBlock key={talk.patient.id} className="text-small">
      <Row>
        <Col sm={6}>
          <span className="bg-light-grey2 px-2 py-1">{getDuration(talk)}</span>
        </Col>
        <Col sm={6}>{createdAt}</Col>
        <Col sm={6}>{talk.note}</Col>
        <Col sm={6} style={{ textAlign: 'left' }}>
          <Button
            onClick={handleEdit}
            intent="primary"
            className="mr-2"
            variant="minimal"
            bare
          >
            <Icon icon={faEdit} /> Edit
          </Button>
          <Button
            onClick={() => deleteTalk(talk.id)}
            intent="danger"
            variant="minimal"
            bare
          >
            <Icon icon={faTrash} /> Delete
          </Button>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col>Logged by {talk.user.email}</Col>
      </Row>
    </CardBlock>
  );
};

export default PatientTrackedTimeItem;
